// extracted by mini-css-extract-plugin
module.exports = {"text":"not-found-module--text--1Nw7W","notFound":"not-found-module--not-found--lLKsi not-found-module--text--1Nw7W"};